import moment from 'moment';
import { inputTypes } from '../helpers/enums';

export const newHourForm_admin = {
  projectId: {
    label: 'Project',
    type: inputTypes.projectsSelect,
    multiple: false,
    validation: {
      required: true,
    }
  },
  userId: {
    label: 'User',
    type: inputTypes.usersSelect,
    multiple: false,
    validation: {
      required: true,
    }
  },
  startedAt: {
    label: 'Started at',
    type: inputTypes.timePicker,
    validation: {
      required: true,
    }
  },
  finishedAt: {
    label: 'Finished at',
    type: inputTypes.timePicker,
    validation: {
      required: true,
    }
  },
  date: {
    label: 'Date',
    type: inputTypes.date,
    validation: {
      required: true,
    }
  },
  totalTime: {
    label: 'Total time',
    type: inputTypes.timeAmountPicker,
    validation: {
      required: true,
      pattern: /^[0-9]{1,2}:[0-9]{1,2}$/,
    }
  },
  hourlyRate: {
    label: 'Hourly rate',
    type: inputTypes.number,
    validation: {
      pattern: /^[0-9\.]+$/,
    }
  },
  monthlyRate: {
    label: 'Monthly rate',
    type: inputTypes.number,
    validation: {
      pattern: /^[0-9\.]+$/,
    }
  },
  notes: {
    label: 'Notes',
    type: inputTypes.text,
    as: 'textarea',
    placeholder: 'Enter notes',
  },
};

export const newHourForm = {
  projectId: {
    label: 'Project',
    type: inputTypes.projectsSelect,
    multiple: false,
    validation: {
      required: true,
    }
  },
  startedAt: {
    label: 'Started at',
    type: inputTypes.timePicker,
    validation: {
      required: true,
    }
  },
  finishedAt: {
    label: 'Finished at',
    type: inputTypes.timePicker,
    validation: {
      required: true,
    }
  },
  date: {
    label: 'Date',
    type: inputTypes.date,
    validation: {
      required: true,
    },
    min: moment().subtract(1, 'months').format('YYYY-MM-DD'),
  },
  totalTime: {
    label: 'Total time',
    type: inputTypes.timeAmountPicker,
    validation: {
      required: true,
      pattern: /^[0-9]{1,2}:[0-9]{1,2}$/,
    }
  },
  notes: {
    label: 'Notes',
    type: inputTypes.text,
    as: 'textarea',
    placeholder: 'Enter notes',
  },
};
